import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useRef, useState, useEffect } from "react";
import { clsx } from "clsx";
import { Button, pick, useGraphiQL, UnStyledButton, CloseIcon, MethodPill, Tooltip, PenIcon, StarFilledIcon, StarIcon, TrashIcon, PanelHeader } from "@graphiql/react";
import { useHistory, useHistoryActions } from "./context.js";
const History = () => {
  const $ = c(29);
  const all = useHistory();
  const {
    deleteFromHistory
  } = useHistoryActions();
  let hasFavorites;
  let hasItems;
  let items;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== all || $[1] !== deleteFromHistory) {
    items = all.slice().map(_temp).reverse();
    const favorites = items.filter(_temp2);
    if (favorites.length) {
      items = items.filter(_temp3);
    }
    const handleClear = () => {
      for (const item_2 of items) {
        deleteFromHistory(item_2, true);
      }
    };
    hasFavorites = Boolean(favorites.length);
    hasItems = Boolean(items.length);
    const clearButton = hasItems ? /* @__PURE__ */ jsx(Button, { type: "button", onClick: handleClear, children: "Clear" }) : void 0;
    t0 = "History";
    t1 = "graphiql-history";
    if ($[10] !== clearButton) {
      t2 = /* @__PURE__ */ jsx(PanelHeader, { title: "History", subtitle: "Last 20 runs.", actions: clearButton });
      $[10] = clearButton;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    if ($[12] !== hasFavorites || $[13] !== hasItems) {
      t3 = !hasFavorites && !hasItems && /* @__PURE__ */ jsx("div", { className: "graphiql-history-empty", children: "No queries run yet." });
      $[12] = hasFavorites;
      $[13] = hasItems;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    t4 = hasFavorites && /* @__PURE__ */ jsx("ul", { className: "graphiql-history-items", children: favorites.map(_temp4) });
    $[0] = all;
    $[1] = deleteFromHistory;
    $[2] = hasFavorites;
    $[3] = hasItems;
    $[4] = items;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    hasFavorites = $[2];
    hasItems = $[3];
    items = $[4];
    t0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[15] !== hasFavorites || $[16] !== hasItems) {
    t5 = hasFavorites && hasItems && /* @__PURE__ */ jsx("div", { className: "graphiql-history-item-spacer" });
    $[15] = hasFavorites;
    $[16] = hasItems;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== hasItems || $[19] !== items) {
    t6 = hasItems && /* @__PURE__ */ jsx("ul", { className: "graphiql-history-items", children: items.map(_temp5) });
    $[18] = hasItems;
    $[19] = items;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t0 || $[22] !== t1 || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t7 = /* @__PURE__ */ jsxs("section", { "aria-label": t0, className: t1, children: [
      t2,
      t3,
      t4,
      t5,
      t6
    ] });
    $[21] = t0;
    $[22] = t1;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
};
const HistoryItem = (props) => {
  const $ = c(42);
  const {
    editLabel,
    toggleFavorite,
    deleteFromHistory,
    setActive
  } = useHistoryActions();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = pick("headerEditor", "queryEditor", "variableEditor");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    headerEditor,
    queryEditor,
    variableEditor
  } = useGraphiQL(t0);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  const editButtonRef = useRef(null);
  const [isEditable, setIsEditable] = useState(false);
  const wasEditable = useRef(false);
  let t1;
  let t2;
  if ($[1] !== isEditable) {
    t1 = () => {
      var _a, _b;
      if (isEditable) {
        (_a = inputRef.current) == null ? void 0 : _a.focus();
      } else {
        if (wasEditable.current) {
          (_b = editButtonRef.current) == null ? void 0 : _b.focus();
        }
      }
      wasEditable.current = isEditable;
    };
    t2 = [isEditable];
    $[1] = isEditable;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== props.item.label || $[5] !== props.item.operationName || $[6] !== props.item.query) {
    t3 = props.item.label || props.item.operationName || formatQuery(props.item.query);
    $[4] = props.item.label;
    $[5] = props.item.operationName;
    $[6] = props.item.query;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const displayName = t3;
  let t4;
  if ($[8] !== editLabel || $[9] !== props.item) {
    t4 = () => {
      var _a;
      setIsEditable(false);
      const {
        index,
        ...item
      } = props.item;
      editLabel({
        ...item,
        label: (_a = inputRef.current) == null ? void 0 : _a.value
      }, index);
    };
    $[8] = editLabel;
    $[9] = props.item;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleSave = t4;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsEditable(false);
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleClose = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = (e) => {
      e.stopPropagation();
      setIsEditable(true);
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleEditLabel = t6;
  let t7;
  if ($[13] !== headerEditor || $[14] !== props.item || $[15] !== queryEditor || $[16] !== setActive || $[17] !== variableEditor) {
    t7 = () => {
      const {
        query,
        variables,
        headers
      } = props.item;
      queryEditor == null ? void 0 : queryEditor.setValue(query ?? "");
      variableEditor == null ? void 0 : variableEditor.setValue(variables ?? "");
      headerEditor == null ? void 0 : headerEditor.setValue(headers ?? "");
      setActive(props.item);
    };
    $[13] = headerEditor;
    $[14] = props.item;
    $[15] = queryEditor;
    $[16] = setActive;
    $[17] = variableEditor;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const handleHistoryItemClick = t7;
  let t8;
  if ($[19] !== deleteFromHistory || $[20] !== props.item) {
    t8 = (e_0) => {
      e_0.stopPropagation();
      deleteFromHistory(props.item);
    };
    $[19] = deleteFromHistory;
    $[20] = props.item;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const handleDeleteItemFromHistory = t8;
  let t9;
  if ($[22] !== props.item || $[23] !== toggleFavorite) {
    t9 = (e_1) => {
      e_1.stopPropagation();
      toggleFavorite(props.item);
    };
    $[22] = props.item;
    $[23] = toggleFavorite;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const handleToggleFavorite = t9;
  let t10;
  if ($[25] !== props.item.variables) {
    t10 = props.item.variables ? formatVariables(props.item.variables) : null;
    $[25] = props.item.variables;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const variablesSnippet = t10;
  const t11 = isEditable && "editable";
  let t12;
  if ($[27] !== t11) {
    t12 = clsx("graphiql-history-item", t11);
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== displayName || $[30] !== editLabel || $[31] !== handleDeleteItemFromHistory || $[32] !== handleHistoryItemClick || $[33] !== handleSave || $[34] !== handleToggleFavorite || $[35] !== isEditable || $[36] !== props.item || $[37] !== variablesSnippet) {
    t13 = isEditable ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("input", { type: "text", defaultValue: props.item.label, ref: inputRef, onKeyDown: (e_2) => {
        if (e_2.key === "Escape") {
          setIsEditable(false);
        } else {
          if (e_2.key === "Enter") {
            setIsEditable(false);
            editLabel({
              ...props.item,
              label: e_2.currentTarget.value
            });
          }
        }
      }, placeholder: "Type a label" }),
      /* @__PURE__ */ jsx(UnStyledButton, { type: "button", ref: buttonRef, onClick: handleSave, children: "Save" }),
      /* @__PURE__ */ jsx(UnStyledButton, { type: "button", ref: buttonRef, onClick: handleClose, "aria-label": "Cancel", children: /* @__PURE__ */ jsx(CloseIcon, { "aria-hidden": "true" }) })
    ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "graphiql-history-item-inner", children: [
        /* @__PURE__ */ jsxs("div", { className: "graphiql-history-item-row", children: [
          props.item.operation && /* @__PURE__ */ jsx(MethodPill, { operation: props.item.operation, "aria-hidden": true }),
          /* @__PURE__ */ jsx(Tooltip, { label: "Set active", children: /* @__PURE__ */ jsx(UnStyledButton, { type: "button", className: "graphiql-history-item-label", onClick: handleHistoryItemClick, "aria-label": "Set active", children: displayName }) })
        ] }),
        variablesSnippet && /* @__PURE__ */ jsx("div", { className: "graphiql-history-item-meta", children: /* @__PURE__ */ jsx("span", { className: "graphiql-history-item-variables", children: variablesSnippet }) })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "graphiql-history-item-actions", children: [
        /* @__PURE__ */ jsx(Tooltip, { label: "Edit label", children: /* @__PURE__ */ jsx(UnStyledButton, { ref: editButtonRef, type: "button", className: "graphiql-history-item-action", onClick: handleEditLabel, "aria-label": "Edit label", children: /* @__PURE__ */ jsx(PenIcon, { "aria-hidden": "true" }) }) }),
        /* @__PURE__ */ jsx(Tooltip, { label: props.item.favorite ? "Remove favorite" : "Add favorite", children: /* @__PURE__ */ jsx(UnStyledButton, { type: "button", className: "graphiql-history-item-action", onClick: handleToggleFavorite, "aria-label": props.item.favorite ? "Remove favorite" : "Add favorite", children: props.item.favorite ? /* @__PURE__ */ jsx(StarFilledIcon, { "aria-hidden": "true" }) : /* @__PURE__ */ jsx(StarIcon, { "aria-hidden": "true" }) }) }),
        /* @__PURE__ */ jsx(Tooltip, { label: "Delete from history", children: /* @__PURE__ */ jsx(UnStyledButton, { type: "button", className: "graphiql-history-item-action", onClick: handleDeleteItemFromHistory, "aria-label": "Delete from history", children: /* @__PURE__ */ jsx(TrashIcon, { "aria-hidden": "true" }) }) })
      ] })
    ] });
    $[29] = displayName;
    $[30] = editLabel;
    $[31] = handleDeleteItemFromHistory;
    $[32] = handleHistoryItemClick;
    $[33] = handleSave;
    $[34] = handleToggleFavorite;
    $[35] = isEditable;
    $[36] = props.item;
    $[37] = variablesSnippet;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t12 || $[40] !== t13) {
    t14 = /* @__PURE__ */ jsx("li", { className: t12, children: t13 });
    $[39] = t12;
    $[40] = t13;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  return t14;
};
function formatQuery(query) {
  return query == null ? void 0 : query.split("\n").map((line) => line.replace(/#(.*)/, "")).join(" ").replaceAll("{", " { ").replaceAll("}", " } ").replaceAll(/[\s]{2,}/g, " ");
}
function formatVariables(variables) {
  try {
    const parsed = JSON.parse(variables);
    const entries = Object.entries(parsed);
    if (!entries.length) {
      return null;
    }
    return entries.slice(0, 3).map(([k, v]) => `${k}: ${JSON.stringify(v)}`).join(", ");
  } catch {
    return variables.slice(0, 60);
  }
}
function _temp(item, i) {
  return {
    ...item,
    index: i
  };
}
function _temp2(item_0) {
  return item_0.favorite;
}
function _temp3(item_1) {
  return !item_1.favorite;
}
function _temp4(item_3) {
  return /* @__PURE__ */ jsx(HistoryItem, { item: item_3 }, item_3.index);
}
function _temp5(item_4) {
  return /* @__PURE__ */ jsx(HistoryItem, { item: item_4 }, item_4.index);
}
export {
  History,
  HistoryItem,
  formatQuery,
  formatVariables
};
//# sourceMappingURL=components.js.map
